import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "timer-rule"
};
const _hoisted_2 = {
  class: "btn-group"
};
import { ref, reactive, watch, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { mctRequest } from '@/api/axios';
import timezoneList from '@/utils/timezoneList';
import { storeToRefs } from 'pinia';
import { useSetTimerStore } from '@/store/setTimer';
export default /*@__PURE__*/_defineComponent({
  __name: 'TimerRule',
  setup(__props) {
    const useSetTimer = useSetTimerStore();
    const {
      timerRuleDialogVisible,
      refreshTimerRule,
      currRuleId
    } = storeToRefs(useSetTimer);
    const ruleFormRef = ref();
    const ruleForm = reactive({
      name: '',
      interval: '',
      runOfDays: [],
      timeSlot: [8, 18],
      timeZone: ''
    });
    const rules = reactive({
      name: [{
        required: true,
        message: 'please input',
        trigger: 'blur'
      }],
      interval: [{
        required: true,
        message: 'please select',
        trigger: 'change'
      }],
      runOfDays: [{
        required: true,
        message: 'please select',
        trigger: 'change'
      }],
      timeSlot: [{
        required: true,
        message: 'please select',
        trigger: 'change'
      }],
      timeZone: [{
        required: true,
        message: 'please select',
        trigger: 'change'
      }]
    });
    const intervalOptions = [{
      label: 'Minutes',
      options: [{
        value: 1,
        label: 'every 1 min'
      }, {
        value: 2,
        label: 'every 2 min'
      }, {
        value: 3,
        label: 'every 3 min'
      }, {
        value: 4,
        label: 'every 4 min'
      }, {
        value: 5,
        label: 'every 5 min'
      }, {
        value: 6,
        label: 'every 6 min'
      }, {
        value: 10,
        label: 'every 10 min'
      }, {
        value: 12,
        label: 'every 12 min'
      }, {
        value: 15,
        label: 'every 15 min'
      }, {
        value: 20,
        label: 'every 20 min'
      }, {
        value: 30,
        label: 'every 30 min'
      }, {
        value: 59,
        label: 'every 59 min'
      }]
    }, {
      label: 'Hours',
      options: [{
        value: 60,
        label: 'every 1 hour'
      }, {
        value: 120,
        label: 'every 2 hour'
      }, {
        value: 180,
        label: 'every 3 hour'
      }, {
        value: 240,
        label: 'every 4 hour'
      }, {
        value: 300,
        label: 'every 5 hour'
      }, {
        value: 360,
        label: 'every 6 hour'
      }, {
        value: 420,
        label: 'every 7 hour'
      }, {
        value: 480,
        label: 'every 8 hour'
      }, {
        value: 540,
        label: 'every 9 hour'
      }, {
        value: 600,
        label: 'every 10 hour'
      }, {
        value: 660,
        label: 'every 11 hour'
      }, {
        value: 720,
        label: 'every 12 hour'
      }]
    }];
    const weeks = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    const marks = reactive({
      0: '0:00',
      4: '4:00',
      8: '8:00',
      12: '12:00',
      16: '16:00',
      20: '20:00',
      24: '24:00'
    });
    const formatTooltip = val => {
      const hour = Math.floor(val);
      const minutes = Math.round((val - hour) * 60);
      const hourStr = hour.toString().padStart(2, '0');
      const minStr = minutes.toString().padStart(2, '0');
      return `${hourStr}:${minStr}`;
    };
    const initEditTimerRule = async () => {
      const config = {
        url: `/timerSettingRule/query?ruleId=${currRuleId.value}`
      };
      const {
        timerSettingRuleList
      } = await mctRequest.request(config);
      const rule = timerSettingRuleList[0];
      ruleForm.name = rule.name;
      ruleForm.interval = rule.interval;
      ruleForm.runOfDays = rule.runOfDaysDisplay.split(',');
      ruleForm.timeSlot = [rule.startMinOfDay / 60, rule.endMinOfDay / 60];
      ruleForm.timeZone = rule.timeZone;
    };
    const handleSubmit = async () => {
      if (!ruleFormRef.value) return;
      await ruleFormRef.value.validate(valid => {
        if (valid) {
          submitTimerRule();
        }
      });
    };
    const submitTimerRule = async () => {
      const config = {
        url: '/timerSettingRule',
        method: 'post',
        data: {
          name: ruleForm.name,
          startTime: '0',
          interval: ruleForm.interval.toString(),
          timeZone: ruleForm.timeZone,
          startMinOfDay: duration2MinOfDay(ruleForm.timeSlot)[0],
          endMinOfDay: duration2MinOfDay(ruleForm.timeSlot)[1],
          runOfDays: weeks2Number(ruleForm.runOfDays)
        }
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'Successfully added'
      });
      timerRuleDialogVisible.value = false;
      refreshTimerRule.value++;
    };
    const weeks2Number = arr => {
      const weekMap = {
        MON: 2,
        TUE: 3,
        WED: 4,
        THU: 5,
        FRI: 6,
        SAT: 7,
        SUN: 1
      };
      const weeks = arr.map(item => weekMap[item]);
      weeks.sort();
      const res = weeks.join(',');
      return res;
    };
    const duration2MinOfDay = arr => {
      const [start, end] = arr;
      return [start * 60, end * 60];
    };
    watch(() => currRuleId.value, () => {
      ruleFormRef.value?.resetFields();
      if (currRuleId.value !== 0) {
        initEditTimerRule();
      }
    });
    onMounted(() => {
      if (currRuleId.value !== 0) {
        initEditTimerRule();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_option_group = _resolveComponent("el-option-group");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_checkbox_button = _resolveComponent("el-checkbox-button");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        rules: rules,
        "label-width": "200px",
        "status-icon": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "Name",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: ruleForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.name = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Interval",
          prop: "interval"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: ruleForm.interval,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.interval = $event),
            placeholder: "Select"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(intervalOptions, group => {
              return _createVNode(_component_el_option_group, {
                key: group.label,
                label: group.label
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["label"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Run of Days",
          prop: "runOfDays"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
            modelValue: ruleForm.runOfDays,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ruleForm.runOfDays = $event)
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(weeks, day => {
              return _createVNode(_component_el_checkbox_button, {
                key: day,
                value: day
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(day), 1)]),
                _: 2
              }, 1032, ["value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "time-slot",
          label: "Time Slot",
          prop: "timeSlot"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_slider, {
            modelValue: ruleForm.timeSlot,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ruleForm.timeSlot = $event),
            step: 0.25,
            "format-tooltip": formatTooltip,
            range: "",
            max: 24,
            marks: marks
          }, null, 8, ["modelValue", "marks"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Time Zone",
          prop: "timeZone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: ruleForm.timeZone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ruleForm.timeZone = $event),
            placeholder: "Select time zone"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timezoneList), timezone => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: timezone.label,
                label: timezone.label,
                value: timezone.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        plain: "",
        onClick: _cache[5] || (_cache[5] = $event => timerRuleDialogVisible.value = false)
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" Cancel ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("Submit")])),
        _: 1
      })])]);
    };
  }
});